import type { PaginatedMeta } from "../../types/formList";

export function paginateList<T>(
  items: T[],
  page: number,
  perPage: number,
): { items: T[]; meta: PaginatedMeta } {
  const total = items.length;
  const last_page = Math.max(1, Math.ceil(total / perPage));
  const current_page = Math.min(Math.max(1, page), last_page);
  const start = (current_page - 1) * perPage;
  const end = start + perPage;

  return {
    items: items.slice(start, end),
    meta: {
      current_page,
      last_page,
      per_page: perPage,
      total,
      from: total === 0 ? null : start + 1,
      to: total === 0 ? null : Math.min(end, total),
    },
  };
}
